import * as types from "./actionTypes";
import bovenLokaliteitPerInfrastructuurApi from "../api/bovenLokaliteitPerInfrastructuurApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";
import geographyApi from "../api/geographyApi";


// ----------------------------------------------------------------------------
export function bovenLokaliteitPerInfrastructuurLoaded(bovenLokaliteitPerInfrastructuur, documenten, errors, hasValidationErrors, fileSessionStarted, isSaved = true) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_LOADED,
		body: {
			item: bovenLokaliteitPerInfrastructuur,
			documenten: documenten,
			errors: errors,
			hasValidationErrors: hasValidationErrors,
			isSaved: isSaved,
			fileSessionStarted: fileSessionStarted
		}
	};
}

export function loadBovenLokaliteitPerInfrastructuur(infrastructuurId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return bovenLokaliteitPerInfrastructuurApi.get(infrastructuurId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(bovenLokaliteitPerInfrastructuurLoaded(response.data.item, null, response.data.validationResults, response.data.hasValidationErrors, false));

				//dispatch(getInfrastructurenInDeBuurt(response.data.item.lengtegraad, response.data.item.breedtegraad));

				dispatch(beads.beadsLoaded(response.data.item.beadModels));

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function bovenLokaliteitPerInfrastructuurSaved(bovenLokaliteitPerInfrastructuur, documenten, errors, hasValidationErrors) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_SAVED,
		body: {
			item: bovenLokaliteitPerInfrastructuur,
			documenten: documenten,
			errors: errors,
			hasValidationErrors
		}
	};
}

export function bovenLokaliteitPerInfrastructuurCacheSaved(bovenLokaliteitPerInfrastructuur, documenten, fileSessionStarted, isSaved) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_CACHE_SAVED,
		body: {
			item: bovenLokaliteitPerInfrastructuur,
			documenten: documenten,
			fileSessionStarted: fileSessionStarted,
			isSaved: isSaved
		}
	};
}


export function infrastructuurInDeBuurtValidated(validationErrors) {
	return {
		type: types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_VALIDATED,
		body: {
			errors: validationErrors
		}
	};
}

export function saveBovenLokaliteitPerInfrastructuurCache(bovenLokaliteitPerInfrastructuur, documenten, fileSessionStarted, isSaved) {
	return (dispatch) => {
		dispatch(ajax.started());
		return bovenLokaliteitPerInfrastructuurApi.validateBovenLokaliteitPerInfrastructuur(bovenLokaliteitPerInfrastructuur)
			.then(response => {
				dispatch(ajax.ended());
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(infrastructuurInDeBuurtValidated(response.data.validationResults));
					return constants.HAS_VALIDATION_ERRORS;
				}
				else {
					bovenLokaliteitPerInfrastructuur.tienMinutenWandelen = response.data.item.tienMinutenWandelen;
					dispatch(bovenLokaliteitPerInfrastructuurCacheSaved(bovenLokaliteitPerInfrastructuur, documenten, fileSessionStarted, isSaved));
					return constants.SUCCESS_NO_TOASTR;
				}
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function saveBovenLokaliteitPerInfrastructuur(bovenLokaliteitPerInfrastructuur, documenten) {
	return (dispatch) => {
		dispatch(ajax.started());
		return bovenLokaliteitPerInfrastructuurApi.save(bovenLokaliteitPerInfrastructuur, documenten)
			.then((response) => {
				dispatch(ajax.ended());
				dispatch(bovenLokaliteitPerInfrastructuurSaved(response.data.item, documenten, response.data.validationResults, response.data.hasValidationErrors));
				if (response.data.concurrencyException) {
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (response.data.hasValidationErrors) {
					return constants.HAS_VALIDATION_ERRORS;
				}

				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function resetInfrastructuurErrors() {
	return (dispatch) => {
		dispatch(infrastructuurInDeBuurtValidated(null));
	};
}


export function deleteSportInfrastructuurInDeBuurt(id) {
	return (dispatch) => {
		dispatch(ajax.started());
		return bovenLokaliteitPerInfrastructuurApi.delete(id)
			.then((response) => {
				dispatch(ajax.ended());
				if (response.data.concurrencyException) {
					dispatch(bovenLokaliteitPerInfrastructuurSaved(response.data.item, null, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}


				if (response.data.hasValidationErrors) {
					dispatch(bovenLokaliteitPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS;
				}
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(bovenLokaliteitPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(bovenLokaliteitPerInfrastructuurSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function getEmptySportinfrastructuurInDeBuurt() {
	return (dispatch) => {
		dispatch(ajax.started());
		return bovenLokaliteitPerInfrastructuurApi.loadEmptySportinfrastructuurInDeBuurt()
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}


export function getGeoCoordinates(adres) {
	return (dispatch) => {
		dispatch(ajax.started());

		return geographyApi.getCoordinatenForAdres(adres)
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}